import ACTIONS from '../actions.js'
import { createInitialState } from '../initialState.js'
import { authReducer } from './auth.js'
import { selectionReducer } from './selection.js'
import { emailReducer } from './email.js'
import { templateReducer } from './template.js'
import { uiReducer } from './ui.js'

// Optional: small utility to sequence reducers
const chainReducers =
  (...reducers) =>
  (state, action) =>
    reducers.reduce((s, r) => r(s, action), state)

// Reducer handling generic actions not domain-specific
function genericReducer(state, action) {
  switch (action.type) {
    case ACTIONS.SET_FIELD:
      return { ...state, [action.field]: action.value }
    case ACTIONS.INITIALIZE_FORM:
      return { ...state, ...action.payload }
    default:
      return state
  }
}

function resettableReducer(state, action) {
  if (action.type === ACTIONS.RESET_FORM) {
    return createInitialState(
      action.params,
      action.client,
      action.defaultAuthType,
    )
  }
  return chainReducers(
    genericReducer,
    authReducer,
    selectionReducer,
    emailReducer,
    templateReducer,
    uiReducer,
  )(state, action)
}

export const requestFilesRootReducer = resettableReducer

export default requestFilesRootReducer
